export const CENTER_WIDTH = 594;
export const COLLAPSE_TIMEOUT = 200;
export const GENERAL_ENTITY = 'General';
export const META_FIELDS_TO_HIDE = ['_key', 'source_names', 'state', 'locked', 'created'];

/** Entity types that support multi-instance mapping. */
export const INSTANCE_ELIGIBLE_ENTITIES: ReadonlySet<string> = new Set(['Artifact', 'ARTIFACT', 'CLOUDASSETCONNECTION']);
